import Steps10 from './Steps10'
export default Steps10
